// Coin.js - How coins look using image

export const drawCoin = (ctx, coin, coinImage) => {
  if (coin.collected) return;
  
  ctx.save();
  ctx.translate(coin.x, coin.y);
  
  // Calculate horizontal scale based on angle (creates flip effect)
  const scale = Math.cos(coin.angle);
  
  if (coinImage) {
    // Draw coin image with horizontal flip
    const size = coin.r * 2;
    ctx.scale(scale, 1); // Flip horizontally, keep vertical normal
    ctx.drawImage(coinImage, -size/2, -size/2, size, size);
  } else {
    // Fallback to gold circle with flip
    ctx.scale(scale, 1);
    ctx.fillStyle = '#FFD700';
    ctx.beginPath();
    ctx.arc(0, 0, coin.r, 0, Math.PI * 2);
    ctx.fill();
  }
  
  ctx.restore();
};

export const drawAllCoins = (ctx, coins, coinImage) => {
  coins.forEach(coin => {
    drawCoin(ctx, coin, coinImage);
  });
};